import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientInterface } from '../data';
import { ClientProvider } from '../providers/client.provider';
import { UseCaseWithParam } from './common/use.case.with.params';
import { Transaction } from '../transaction/transaction';

export interface CheckClientUseCaseParams {
    client: ClientInterface;
    captcha: string;
}

@Injectable()
export class CheckClientUseCase implements UseCaseWithParam<CheckClientUseCaseParams, Observable<Transaction<boolean>>> {
    constructor(private clientProvider: ClientProvider) {}

    bind(params: CheckClientUseCaseParams): Observable<Transaction<boolean>> {
        return this.clientProvider.existClient(params.client, params.captcha);
    }
}
